import script from "./WithdrawalTokenSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawalTokenSelect.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawalTokenSelect.vue?vue&type=style&index=0&id=5abb4e0c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5abb4e0c"]])

export default __exports__